import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vaadin': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.5 140.7C226 123.1 229.4 88 274.3 88H372.9C393.6 88 405 80.2 405 66.4V54.1C405 41.9 414.3 32 426.5 32S448 41.9 448 54.1V90.6C448 133.5 426.5 152.6 381.2 152.6H280.7C250.6 152.6 247.7 167.3 247.7 179.7 247.7 181 247.6 182.2 247.5 183.4 246.8 195.7 236.6 205.6 224.1 205.6S201.4 195.8 200.7 183.4C200.6 182.2 200.5 181 200.5 179.7 200.5 167.4 197.5 152.6 167.5 152.6H66.8C21.5 152.6 0 133.5 0 90.6V54.1C0 41.9 9.4 32 21.6 32S43.1 41.9 43.1 54.1V66.4C43.1 80.2 54.5 88 75.2 88H173.8C218.6 88 222.1 123.1 223.6 140.7H224.5zM224 456C235.5 456 245.4 449 249.7 439.7 250.8 437.9 346.8 270.1 347.9 268.3 359.8 248.7 344.7 224 320.7 224 306.8 224 297.4 230.4 290.9 244.3L224 362 157.1 244.3C150.7 230.4 141.2 224 127.3 224 103.3 224 88.2 248.6 100.1 268.3 101.2 270.2 197.2 437.9 198.3 439.7 202.6 449 212.5 456 224 456z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vaadin.js
// module id = /alt
// module chunks = 144